/*
  Kūkai amount pills (e.g. "50 g" + "100 g" on product cards)
  - Hover badges (Refill / Subscription available) align right with the
    first pill by default, or with whichever pill is hovered.
*/
(() => {
  const CONTAINERS = '.kukai-product-card__amount-badges, .kukai-product__amount-badges';

  function setup(root) {
    (root || document).querySelectorAll(CONTAINERS).forEach((container) => {
      if (container.dataset.kukaiPills === 'ready') return;
      const pills = Array.from(container.children);
      if (pills.length < 2) return;
      container.dataset.kukaiPills = 'ready';

      const group = container.parentElement;
      const card = container.closest('a') || group;

      const alignTo = (pill) => {
        const offset = container.getBoundingClientRect().right - pill.getBoundingClientRect().right;
        group.style.setProperty('--kukai-pill-offset', Math.max(0, Math.round(offset)) + 'px');
      };
      const reset = () => alignTo(pills[0]);

      pills.forEach((pill) => {
        pill.style.pointerEvents = 'auto';
        pill.addEventListener('mouseenter', () => alignTo(pill));
        pill.addEventListener('mouseleave', reset);
      });

      card.addEventListener('mouseenter', reset);
      reset();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup());
  } else {
    setup();
  }
  window.addEventListener('load', () => setup());
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
